module.exports = __webpack_public_path__ + "static/media/MercyMinistry.b41dab73.jpg";